var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3FC31287-42F7-4780-89B1-D2361D0EF136") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Management---Suspended-Users",
    transform: "translate(-1252.000000, -479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1252.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09725,3.32475 C5.45816932,2.1454953 7.19923995,1.49748782 9,1.49999272 C13.14225,1.49999272 16.5,4.85775 16.5,8.99999272 C16.5,10.602 15.9975,12.087 15.1425,13.305 L12.75,8.99999272 L15,8.99999272 C15.0001975,6.59545093 13.5648351,4.42303079 11.3528847,3.48009299 C9.14093432,2.53715519 6.57968468,3.00584975 4.845,4.671 L4.09725,3.32475 Z M13.90275,14.67525 C12.5418307,15.8545047 10.80076,16.5025122 9,16.5000073 C4.85775,16.5000073 1.5,13.14225 1.5,9 C1.5,7.398 2.0025,5.913 2.8575,4.695 L5.25,9 L3,9 C2.99980252,11.4045491 4.43516486,13.5769692 6.64711527,14.519907 C8.85906568,15.4628448 11.4203153,14.9941502 13.155,13.329 L13.90275,14.67525 L13.90275,14.67525 Z",
    id: "Shape",
    fill: "#747D84",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.6f89a1997e7958bfcf3da2b5d50cae96.svg";
export { ForwardRef as ReactComponent };